/* eslint-disable no-shadow */
export enum SubstitutionTypeEnum {
  exceptionSearch = 'exceptionSearch',
  replacementSearch = 'replacementSearch',
  substituteSearch = 'substituteSearch',
}
